import Filter from './Filter';

export default Filter;



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Filters/Filter/index.js